module.exports = __webpack_public_path__ + "img/inbox.606c2757.png";